import { getAxiosInstance } from "../Config/axios";
import { downloadExcelBase64File } from "../Helpers";


export const getCustomReportService = async (parameters) => {
    try {
        const axios = getAxiosInstance();
        const options = {
            method: 'POST',
            data: parameters,
            url: 'download/custom-report-excel'
        };
    
        const result = await axios(options);

        if(!result?.data?.file) {
            throw new Error('No file');
        }

        downloadExcelBase64File(result.data.file.replace('data:application/vnd.ms-excel;base64,', ''), `Custom Report.xlsx`);

        return result.file;
        
    } catch (error) {
        throw error
    }
};
